var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c(
        "v-app",
        {
          staticClass: "portal-app",
          class: _vm.portalBrandClasses,
          style: _vm.appStyle,
          attrs: { "data-app": "" }
        },
        [
          _vm.$store.state.isLoggedIn
            ? _c(
                "div",
                {
                  staticClass: "portal-frame",
                  style:
                    "--v-right-nav-width:" +
                    _vm.rightNavWidth +
                    "; --v-left-nav-width:" +
                    _vm.leftNavWidth +
                    ";"
                },
                [
                  _c("top-nav"),
                  _c("div", { staticClass: "portal-workspace" }, [
                    _c(
                      "aside",
                      {
                        staticClass: "d-none d-sm-flex",
                        attrs: {
                          id: "left-nav",
                          "aria-label": _vm.$t("nav.portal-navigation")
                        }
                      },
                      [_c("left-nav")],
                      1
                    ),
                    _c("div", { attrs: { id: "right-section" } }, [
                      _c("div", { attrs: { id: "main-app" } }, [
                        _c(
                          "main",
                          {
                            class: {
                              "is-full-bleed": _vm.$route.meta.fullBleed
                            },
                            attrs: { id: "main-content" }
                          },
                          [_c("v-main", [_c("router-view")], 1)],
                          1
                        ),
                        _c(
                          "aside",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.mobile,
                                expression: "!mobile"
                              }
                            ],
                            attrs: {
                              id: "right-bar",
                              "aria-label": _vm.$t("nav.notifications")
                            }
                          },
                          [_c("right-nav")],
                          1
                        )
                      ])
                    ])
                  ]),
                  _c("mobile-nav", { staticClass: "d-flex d-sm-none" })
                ],
                1
              )
            : _c(
                "div",
                { staticStyle: { height: "100%" } },
                [_c("router-view")],
                1
              ),
          _c(
            "v-snackbar",
            {
              staticStyle: { "font-size": "1.1em" },
              attrs: {
                id: "main-snackbar",
                color: _vm.color,
                timeout: _vm.timeout,
                top: true
              },
              model: {
                value: _vm.show,
                callback: function($$v) {
                  _vm.show = $$v
                },
                expression: "show"
              }
            },
            [
              _c("div", [_vm._v(_vm._s(_vm.message))]),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", icon: "", id: "main-snackbar-close" },
                  on: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-overlay",
            {
              staticStyle: { "z-index": "1000" },
              attrs: { value: _vm.$store.state.loadingState }
            },
            [
              _c(
                "div",
                {
                  staticClass: "loading-status",
                  attrs: { role: "status", "aria-live": "polite" }
                },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "64" }
                  }),
                  _vm.$store.state.loadingMessage
                    ? _c("div", [
                        _vm._v(_vm._s(_vm.$store.state.loadingMessage))
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c("global-modal-controller", { ref: "gmc" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }